export default "__VITE_ASSET__CjcD99BK__"